export default __webpack_public_path__ + "static/media/6c8055dd05659a50f8b65441d2067cab.jpg";